// Detects the runtime platform. iOS users must use Apple IAP (RevenueCat);
// web and Android-web users go through Lemon Squeezy.
export type Platform = "web" | "ios" | "android";

export function isPlatform(): Platform {
  if (typeof window === "undefined") return "web";
  const cap = (window as any).Capacitor;
  if (cap?.isNativePlatform?.() || cap?.isNative) {
    const p = cap.getPlatform?.() ?? cap.platform;
    if (p === "ios") return "ios";
    if (p === "android") return "android";
  }
  return "web";
}

export function isIOSNative(): boolean {
  return isPlatform() === "ios";
}

// Map internal plan keys (resolved to Lemon Squeezy variant IDs on web) to RevenueCat product identifiers
// (configured in App Store Connect + RevenueCat dashboard).
export const REVENUECAT_PRODUCTS: Record<string, string> = {
  household_annual: "app.checkbloom.household.annual",
  household_monthly: "app.checkbloom.household.monthly",
  pro_annual: "app.checkbloom.pro.annual",
  pro_monthly: "app.checkbloom.pro.monthly",
  lifetime_onetime: "app.checkbloom.lifetime",
};
